// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom_wrwk0.win_AtbLk {
  align-items: flex-end;
}

.padBottom_qSNqI {
  margin-bottom: 12px;
}

.grow_nv_Ou {
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-fota-management/lib/views/itemEditor/attributeEditors/ComponentTypesEditor.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".bottom.win {\n  align-items: flex-end;\n}\n\n.padBottom {\n  margin-bottom: 12px;\n}\n\n.grow {\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bottom": `bottom_wrwk0`,
	"win": `win_AtbLk`,
	"padBottom": `padBottom_qSNqI`,
	"grow": `grow_nv_Ou`
};
export default ___CSS_LOADER_EXPORT___;
